var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightRocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 848,
    viewBox: "0 0 736 848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_21791)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M670.075 261.087C669.449 279.848 647.3 377.429 647.3 377.429L647.926 417.942L627.693 438.207C627.693 438.207 628.946 478.193 625.795 485.118C622.645 492.044 608.713 527.231 608.713 527.231L594.782 646.132L615.508 637.463L629.212 638.855L639.195 639.862L607.442 691.444L600.951 712.508L573.278 802.332C573.278 802.332 599.85 845.516 609.34 854.057L620.728 859.383L619.779 871.794L619.57 874.354H619.133L495.232 869.955L436.736 867.876L443.854 863.35L465.206 802.3L478.967 799.373V793.423C478.967 793.423 496.049 725.047 510.284 699.057L517.401 694.658H508.499C508.499 694.658 491.152 660.543 487.982 640.006L504.741 627.211L473.121 581.371L473.425 572.031L482.611 554.709L491.778 545.384L491.152 545.096L490.563 544.825L490.203 544.665L489.5 544.345C481.643 540.73 455.982 528.91 453.002 527.839H452.869C450.345 527.039 440.855 527.839 440.855 527.839L303.877 513.444L297.86 509.973H235.454L216 497.53L227.862 475.937L227.388 469.54L274.838 441.55L309.002 397.166L325.134 390.368L339.369 360.779L394.411 319.194L427.152 324.392C427.152 324.392 533.439 265.485 587.855 258.016L613.155 264.414L617.919 263.87L619.456 263.694L625.15 263.038L643.257 260.975L649.862 260.223L659.124 259.168L663.375 258.688L664.837 258.528L666.545 258.336L667.969 258.176L669.43 258.016C669.962 257.952 670.151 259.056 670.075 261.087Z",
    fill: "url(#paint0_linear_545_21791)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.359 854.057L620.747 859.383L619.779 871.794L619.133 874.337L436.736 867.86L443.854 863.333L465.206 802.283C463.308 814.807 478.018 842.013 478.018 842.013L534.009 857.735L544.011 850.522L504.59 802.283L478.967 799.356V793.423C478.967 793.423 496.049 725.047 510.284 699.057L547.048 702.655L571.019 676.937L590.474 665.869L629.269 638.854L639.252 639.862L607.499 691.443L573.335 802.331C573.335 802.331 599.869 845.516 609.359 854.057Z",
    fill: "url(#paint1_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.945 417.942L627.712 438.207C627.712 438.207 628.965 478.192 625.814 485.118C622.664 492.043 608.733 527.231 608.733 527.231L594.801 646.132L589.904 654.257L549.553 694.642H508.386C508.386 694.642 491.038 660.527 487.868 639.99L497.833 639.862L553.824 656.256L583.717 622.94L585.615 616.67L543.859 627.195H504.628L473.007 581.355L545.283 570.687L591.309 529.518L553.349 545.912L515.389 555.109L491.664 545.384L491.038 545.096L490.45 544.824L490.089 544.664L489.387 544.345L452.888 527.839H452.755H440.741L429.657 506.774L426.506 496.106L344.722 471.059L319.573 496.106L303.763 513.444L297.747 509.973L323.692 490.444L336.978 476.849L307.882 435.008L274.838 441.55L309.476 421.429L359.773 409.961L416.713 381.971L425.254 354.781L481.244 317.195L587.855 258.016L613.155 264.414L617.919 263.87L619.456 263.694L625.15 263.038L643.257 260.975L649.862 260.223L664.837 258.528L666.545 258.336L667.969 258.176L669.43 258.016L670.038 261.103C669.411 279.864 647.262 377.445 647.262 377.445L647.945 417.942Z",
    fill: "url(#paint2_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.759 863.365L462.264 862.438L477.923 842.045L533.914 857.767L543.916 850.554L504.495 802.315L478.872 799.388V793.391H535.584H546.972L600.97 712.492L573.297 802.315L562.156 817.782L546.725 809.385L541.98 811.192L555.987 852.057L600.97 856.248L609.359 854.041L620.747 859.367L619.038 874.369L495.138 869.971L436.641 867.892L443.759 863.365Z",
    fill: "url(#paint3_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.814 485.118C622.645 492.043 608.733 527.231 608.733 527.231L594.801 646.132L589.904 654.257L549.553 694.642L553.824 656.256L583.717 622.94L585.615 616.67L543.859 627.195H504.628L547.181 624.54L555.247 602.675L578.972 592.007L582.635 537.275L591.309 529.518L553.349 545.912L515.389 555.109L491.664 545.384L516.964 551.51L553.026 544.504L588.974 523.792L625.814 485.118Z",
    fill: "url(#paint4_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.924 676.905L590.853 694.626L607.461 691.427L639.214 639.846L629.231 638.838L570.924 676.905Z",
    fill: "url(#paint5_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.945 417.926L630.237 411.528L589.107 417.926L554.317 425.923H547.351L550.521 420.853L504.343 436.32L469.856 461.382L460.689 464.309L440.437 485.102L429.999 498.169L460.366 469.38L487.887 454.841L556.538 434.192L625.814 427.795L627.712 438.191L647.945 417.926Z",
    fill: "url(#paint6_linear_545_21791)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216 497.497L274.838 456.152L307.901 434.992L274.838 441.518L227.862 475.905L216 497.497Z",
    fill: "#452C8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.683 545.352L482.516 554.677L473.33 571.999L473.026 581.339L545.302 570.671L553.368 545.88L515.408 555.077L491.683 545.352Z",
    fill: "#452C8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.135 390.336L453.097 320.361L554.412 276.553L416.39 356.62L325.135 390.336Z",
    fill: "#4A328D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.318 377.429L669.468 258L613.155 264.398L587.855 258L541.354 390.368L491.683 435.024L489.33 447.26L469.837 461.399L460.67 464.325L429.979 498.185L440.741 527.775H452.755L456.077 489.117L502.255 454.857L568.533 447.244L588.936 523.776L552.988 544.488L553.349 545.896L591.309 529.518L611.921 519.186L625.795 485.134C625.795 485.134 628.642 452.362 627.693 438.223L647.926 417.958L647.318 377.429ZM504.343 436.336V430.738L545.112 394.063L589.107 417.942L504.343 436.336Z",
    fill: "url(#paint7_linear_545_21791)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.646 627.179L487.887 639.974L497.852 639.846L543.878 627.179H504.646Z",
    fill: "#43377A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.801 646.116L570.924 676.905L620.747 639.974L615.527 637.447L594.801 646.116Z",
    fill: "#413470"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.413 515.539L350.568 472.77L405.002 410.841L564.035 325.799L662.009 309.101L653.601 349.007L563.181 339.554L528.694 360.875L418.288 424.324L374.957 480.24L361.329 519.41L324.413 515.539Z",
    fill: "#84989F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.16 520.753L390.862 485.102L472.457 425.731L546.744 375.014L646.616 381.939L647.945 390.336L558.758 378.213L544.504 379.54L462.587 434.992L397.106 488.301L382.549 521.649L374.16 520.753Z",
    fill: "#979FB3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.077 394.063L425.254 354.749L416.713 381.939L392.077 394.063Z",
    fill: "#4A328D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.369 360.747L368.94 354.749L394.411 319.162L339.369 360.747Z",
    fill: "#4A328D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.411 319.162L427.152 324.36L390.217 354.749H368.94L394.411 319.162Z",
    fill: "url(#paint8_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.264 531.485L538.962 513.364L580.965 493.819L627.959 456.152V478.192L586.184 513.364L545.112 539.626L511.062 543.081L479.024 539.626L462.264 531.485Z",
    fill: "#84989F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.992 734.324H537.918L577.89 729.014L598.996 718.874L590.929 745.056L559.252 751.102H505.596L493.202 746.528L495.992 734.324Z",
    fill: "#84989F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.007 756.604L504.343 757.596H557.468L588.481 751.102L588.082 754.349L561.909 759.595L535.014 766.073L487.887 760.395L489.007 756.604Z",
    fill: "#84989F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.189 699.057L546.953 702.655L543.859 785.154L528.675 792.367L478.853 793.407C478.853 793.407 500.205 722.632 510.189 699.057Z",
    fill: "#8EB8B0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.2 850.65L470.331 825.715L519.717 820.933L523.626 824.18L472.191 827.378L445.714 857.767L448.2 850.65Z",
    fill: "#84989F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.324 827.442L466.668 815.111L512.922 812.616L505.88 804.027L464.979 805.642L456.324 827.442Z",
    fill: "#84989F"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.829 651.842L562.478 646.612L553.368 660.511L538.829 651.842Z",
    fill: "#413470"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.202 453.241L502.293 454.841L568.552 447.228L588.955 523.76L579.465 470.307L574.967 453.321L577.567 436.719L625.814 427.795L627.712 438.191L647.945 417.926L630.237 411.528L554.317 425.923H547.351L502.843 437.519L493.202 453.241Z",
    fill: "url(#paint9_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.199 624.524L555.266 602.659L578.991 591.991L585.311 581.131L582.654 537.259L588.006 595.862L599.223 608.321L591.802 616.255L585.634 616.654L547.199 624.524Z",
    fill: "url(#paint10_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.306 694.626L513.207 697.169L549.572 694.626H517.306Z",
    fill: "url(#paint11_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.525 496.026L429.999 478.192L417.662 386.338L416.713 381.939L425.254 354.749L423.128 380.548L425.254 437.727L448.105 478.192L437.211 490.204L429.999 498.169L426.525 496.026Z",
    fill: "url(#paint12_linear_545_21791)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.929 581.339L504.267 579.58L499.351 583.77L494.929 581.339Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.937 736.211L620.747 656.512L693.117 622.924L702.36 646.852V664.173L722.289 670.843L671.442 746.448H693.117L754.555 734.324L768.619 739.49L757.402 784.85L718.493 825.715L670.075 867.38V878L561.909 874.769L605.069 834.544L616.951 833.536V825.715L573.297 802.315L554.943 750.462L558.758 742.609L537.937 736.211Z",
    fill: "url(#paint13_linear_545_21791)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.918 736.211L564.889 741.761L577.89 740.61L656.808 712.492L698.09 651.842L693.117 622.924L620.747 656.512L537.918 736.211Z",
    fill: "#5955B1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.117 746.448H671.442L722.27 670.843L702.341 664.189V646.851L693.098 622.94L698.071 651.858L656.79 712.508L570.906 743.025L537.899 736.227L558.777 742.625L577.757 747.423L657.853 722.904L587.892 755.292L555.038 750.494L573.392 802.347L617.046 825.747V833.568L670.19 826.163L705.093 794.814L726.674 793.455L667.039 839.134L615.641 838.478L605.183 834.576L562.023 874.801L670.208 878V867.396L718.474 825.731L757.383 784.866L768.619 739.49L754.536 734.324L693.117 746.448ZM754.536 769.431L712.458 784.882L719.746 745.568L754.536 734.372V769.431Z",
    fill: "url(#paint14_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.117 746.448L718.019 747.407L705.568 784.85L676.263 820.581L616.951 833.536V825.715L573.297 802.315L642.099 781.395L657.757 722.888L577.662 747.407L570.924 743.009L656.808 712.492L698.09 651.842L702.36 664.173L680.533 704.623L722.289 670.843L671.442 746.448H693.117Z",
    fill: "url(#paint15_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.951 825.715L674.517 819.381L686.55 805.658L704.41 784.85L718.019 747.407L705.568 784.85L676.263 820.581L616.951 833.536V825.715Z",
    fill: "url(#paint16_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.513 747.407L670.094 782.994L612.452 802.315L579.503 805.642L573.297 802.315L642.099 781.395L662.749 777.045L671.442 746.448L699.513 747.407Z",
    fill: "url(#paint17_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.94 652.961L554.412 738.994L568.988 744.56L562.118 750.942L578.497 800.428L591.176 804.043L626.422 824.244V831.121L630.426 830.241L631.072 823.7L596.68 803.307L584.818 798.301L572.006 754.797L583.869 757.116L594.422 795.598L608.694 791.247L605.392 746.927L611.636 735.731L609.738 728.534L657.416 670.955L653.886 671.339L617.558 711.996H609.662L675.143 631.065L653.886 640.934L607.081 694.146H601.425L637.012 648.755L627.94 652.961Z",
    fill: "#979FB3"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.758 722.888L656.809 712.492L698.09 651.842L702.36 664.173L680.533 704.623L657.758 722.888Z",
    fill: "url(#paint18_linear_545_21791)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.889 741.761L577.89 740.61L574.056 745.056L564.889 741.761Z",
    fill: "#4A328D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.527 838.446L616.951 845.244L645.42 838.83L615.527 838.446Z",
    fill: "#413470"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.739 742.609L577.662 747.407L609.131 737.779L616.951 741.777L587.798 755.276L554.943 750.462L558.739 742.609Z",
    fill: "#452C8D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.356 784.37L648.381 789.984L675.143 818.901L678.863 814.631L657.416 786.961L638.341 782.243L642.27 729.862L639.821 728.086L641.283 717.738L697.217 641.557V638.359L637.012 719.257L634.033 729.862L639.613 731.093L631.356 784.37Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.297 802.315H612.452L656.808 784.85L662.749 777.044L637.734 782.722L573.297 802.315Z",
    fill: "url(#paint19_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.89 740.61L614.161 731.573L657.055 715.179L656.809 712.492L577.89 740.61Z",
    fill: "url(#paint20_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.586 845.244L632.381 852.057L676.51 846.779L707.295 835.344L698.564 842.861L675.086 848.571L630.464 855.368L585.938 852.377L593.586 845.244Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.925 839.102L670.075 867.38L757.402 784.85L726.56 793.423L666.925 839.102Z",
    fill: "url(#paint21_linear_545_21791)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.771 753.229L596.832 751.102L587.532 759.211L573.771 753.229Z",
    fill: "#4A328D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_545_21791)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.989 813.815L183.264 820.63H187.895L177.113 858.053L138.504 860H92.4839C98.0418 844.209 115.957 821.915 115.957 821.915L153.936 824.836L80.1453 807.643L60.3404 805.851C60.6369 800.497 70.0297 785.641 70.0297 785.641L47.798 737.937C46.9734 736.63 46.2486 735.256 45.6304 733.829C44.8124 732.06 44.2921 730.156 44.0927 728.201V727.812C44.0927 722.535 50.2434 701.254 84.2395 675.63C119.143 649.344 170.388 623.058 178.725 623.058C183.672 623.041 188.585 623.917 193.25 625.648C196.325 642.841 191.082 689.902 191.082 689.902L206.218 684.703H212.999V685.541L216 715.545C213.221 735.016 190.989 813.815 190.989 813.815Z",
    fill: "url(#paint22_linear_545_21791)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216 715.545L212.999 685.541L206.125 684.703L190.989 722.029L165.682 756.434C166.275 754.896 185.524 705.284 190.989 689.941C190.989 689.941 196.232 642.88 193.157 625.687L166.59 675.669L146.841 688.967L124.905 700.981V709.743L79.8302 730.499L45.5562 733.867C46.1744 735.295 46.8993 736.669 47.7238 737.976L70.0297 785.641L75.2727 796.661L111.714 794.558L136.947 775.905L144.062 787.899C144.062 787.899 130.408 796.252 129.981 796.661C128.907 796.778 80.1452 807.701 80.1452 807.701L153.936 824.894L155.178 827.503L141.579 832.858L115.957 821.973C115.957 821.973 98.0418 844.268 92.4838 860.058H127.684L177.205 858.111L187.895 820.688H183.264L190.989 813.873C190.989 813.873 213.221 735.016 216 715.545ZM128.925 710.989C131.853 701.098 156.104 686.436 156.104 686.436L183.264 676.701L176.168 701.838L157.327 715.156L128.925 710.989Z",
    fill: "url(#paint23_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.947 775.847L142.45 785.134L161.087 780.968L157.327 715L176.168 701.682L183.264 676.545L180.966 716.616L165.682 756.337L161.662 787.841H144.062L136.947 775.847Z",
    fill: "url(#paint24_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.905 709.704L130.778 735.328L128.925 710.989C128.925 710.989 136.836 698.177 156.104 686.436L169.647 681.53L166.59 675.688L146.841 688.987L124.905 701.001V709.704Z",
    fill: "url(#paint25_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.973 824.621L172.815 820.63L198.9 785.134L190.989 813.815L183.264 820.63L166.794 828.574L155.178 827.445L152.973 824.621Z",
    fill: "url(#paint26_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.947 859.708L141.579 832.799L175.946 828.574L187.895 820.63L177.113 858.053L134.947 859.708Z",
    fill: "url(#paint27_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.989 721.971L207.922 751.002L216 715.487L212.999 685.482L206.125 684.645L190.989 721.971Z",
    fill: "url(#paint28_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4197 790.761L84.2211 794.13L109.936 792.455L135.873 774.328L130.778 737.781L136.947 775.847L111.64 794.5L75.1987 796.603L72.4197 790.761Z",
    fill: "url(#paint29_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.981 796.603L142.209 819.559L153.936 824.836L80.1451 807.643L129.981 796.603Z",
    fill: "url(#paint30_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.946 828.574L177.113 858.053L187.895 820.63L175.946 828.574Z",
    fill: "url(#paint31_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.936 824.836L155.178 827.445L166.794 828.574L183.264 820.63L193.527 792.455L172.815 820.63L153.936 824.836Z",
    fill: "url(#paint32_linear_545_21791)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.805 714.066L161.606 711.982L157.53 718.505L150.805 714.066Z",
    fill: "#413470"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4197 731.122L84.7583 728.143L80.1452 732.193L72.4197 731.122Z",
    fill: "#413470"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.835 829.08L147.285 832.098L140.69 836.421L132.835 829.08Z",
    fill: "#413470"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.157 625.59L166.59 675.571L124.905 700.884V709.646L84.8509 728.143L72.4196 731.122L45.5562 733.77L44.0186 728.143V727.754C44.0186 722.477 50.1693 701.195 84.1654 675.571C119.069 649.286 170.314 623 178.651 623C183.591 622.984 188.498 623.86 193.157 625.59Z",
    fill: "url(#paint33_linear_545_21791)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.894 755.402L80.1452 756.882L94.0401 754.74L130.778 737.781L158.475 735.269L179.262 711.982L181.911 700.027L193.453 660.404L190.989 689.844L180.966 716.616L159.624 755.402L132.835 750.496L97.7454 761.438L78.589 768.039L59.025 761.438L55.894 755.402Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6389 776.314L82.9427 782.817L102.284 779.566L118.588 774.328L134.947 761.399H159.976L165.682 756.337L165.256 759.725L160.106 763.814L134.947 763.502L120.125 776.002L102.747 781.24L82.498 784.278L66.8617 778.923L65.6389 776.314Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.211 813.017L137.392 810.505L173.741 796.603L197.233 756.337L204.199 744.615L213.647 725.865L211.146 738.755L206.403 748.373L193.527 782.331L175.946 800.731L158.438 810.719L140.06 815.528H111.566L103.211 813.017Z",
    fill: "#93839C"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.168 701.682L180.966 716.616L183.264 676.545L176.168 701.682Z",
    fill: "url(#paint34_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.087 780.968L161.662 787.841H144.062L142.45 785.134L161.087 780.968Z",
    fill: "url(#paint35_linear_545_21791)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.947 859.708L140.69 836.421L147.285 832.098L175.946 828.574H166.794L172.815 820.63L161.662 787.841L161.087 780.968L157.53 718.505L161.606 711.982L176.168 701.682L183.264 676.545L169.665 681.471L156.104 686.378L158.438 680.03L166.59 675.571L193.157 625.59L190.989 689.844L180.966 716.616L165.682 756.337L190.989 721.971L206.125 684.645H212.906L216 717.823L190.989 813.815L183.264 820.63H187.895L177.113 858.053L134.947 859.708Z",
    fill: "url(#paint36_linear_545_21791)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_21791",
    x1: 443.057,
    y1: 874.402,
    x2: 443.057,
    y2: 257.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#310A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#310B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#310B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45196D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57257D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_545_21791",
    x1: 436.642,
    y1: 756.62,
    x2: 639.214,
    y2: 756.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_545_21791",
    x1: 274.838,
    y1: 476.321,
    x2: 670.075,
    y2: 476.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_545_21791",
    x1: 436.641,
    y1: 793.423,
    x2: 620.747,
    y2: 793.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_545_21791",
    x1: 491.683,
    y1: 589.88,
    x2: 625.814,
    y2: 589.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_545_21791",
    x1: 570.924,
    y1: 666.732,
    x2: 639.214,
    y2: 666.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_545_21791",
    x1: 429.999,
    y1: 454.841,
    x2: 647.945,
    y2: 454.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_545_21791",
    x1: 429.998,
    y1: 401.948,
    x2: 669.468,
    y2: 401.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_545_21791",
    x1: 368.94,
    y1: 336.963,
    x2: 427.152,
    y2: 336.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_545_21791",
    x1: 493.202,
    y1: 467.652,
    x2: 647.945,
    y2: 467.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_545_21791",
    x1: 547.199,
    y1: 580.891,
    x2: 599.223,
    y2: 580.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_545_21791",
    x1: 513.188,
    y1: 695.89,
    x2: 549.572,
    y2: 695.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_545_21791",
    x1: 416.713,
    y1: 426.451,
    x2: 448.105,
    y2: 426.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_545_21791",
    x1: 653.278,
    y1: 878,
    x2: 653.278,
    y2: 622.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#310A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#310B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#310B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45196D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57257D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_545_21791",
    x1: 537.918,
    y1: 750.462,
    x2: 768.638,
    y2: 750.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_545_21791",
    x1: 570.924,
    y1: 742.689,
    x2: 722.289,
    y2: 742.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_545_21791",
    x1: 616.951,
    y1: 790.48,
    x2: 718.019,
    y2: 790.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_545_21791",
    x1: 573.297,
    y1: 776.037,
    x2: 699.513,
    y2: 776.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_545_21791",
    x1: 656.809,
    y1: 687.365,
    x2: 702.36,
    y2: 687.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_545_21791",
    x1: 573.297,
    y1: 789.68,
    x2: 662.73,
    y2: 789.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_545_21791",
    x1: 577.89,
    y1: 726.551,
    x2: 657.055,
    y2: 726.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_545_21791",
    x1: 666.925,
    y1: 826.115,
    x2: 757.402,
    y2: 826.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_545_21791",
    x1: 130,
    y1: 860,
    x2: 130,
    y2: 623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#310A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#310B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#310B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#45196D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57257D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_545_21791",
    x1: 45.5562,
    y1: 742.805,
    x2: 216,
    y2: 742.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_545_21791",
    x1: 136.947,
    y1: 732.193,
    x2: 183.264,
    y2: 732.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_545_21791",
    x1: 124.905,
    y1: 705.42,
    x2: 169.647,
    y2: 705.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_545_21791",
    x1: 152.973,
    y1: 806.844,
    x2: 198.9,
    y2: 806.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_545_21791",
    x1: 134.947,
    y1: 840.179,
    x2: 187.895,
    y2: 840.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_545_21791",
    x1: 190.989,
    y1: 717.823,
    x2: 216,
    y2: 717.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_545_21791",
    x1: 72.4197,
    y1: 767.202,
    x2: 136.947,
    y2: 767.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_545_21791",
    x1: 80.1451,
    y1: 810.719,
    x2: 153.936,
    y2: 810.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_545_21791",
    x1: 175.946,
    y1: 839.341,
    x2: 187.895,
    y2: 839.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_545_21791",
    x1: 153.936,
    y1: 810.505,
    x2: 193.527,
    y2: 810.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_545_21791",
    x1: 118.569,
    y1: 733.77,
    x2: 118.569,
    y2: 623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D397A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B72FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_545_21791",
    x1: 176.168,
    y1: 696.581,
    x2: 183.264,
    y2: 696.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_545_21791",
    x1: 142.45,
    y1: 784.414,
    x2: 161.662,
    y2: 784.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_545_21791",
    x1: 134.947,
    y1: 742.649,
    x2: 216,
    y2: 742.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_21791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 736,
    height: 899,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_545_21791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 237,
    fill: "white",
    transform: "translate(44 623)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRocks);
export default __webpack_public_path__ + "static/media/rightRocks.e5fda5a34284aae2721a46f7d4ef271c.svg";
export { ForwardRef as ReactComponent };